import { apiEndpoints } from "@/services/api/api";
import { redirect } from "react-router-dom";
import { ResetPasswordDTO } from "../types/resetPasswordTypes";
import { eventBus } from "@/services/event/eventBus";

export async function ResetPasswordAction({ request }: { request: Request }) {
  const formData = await request.formData();
  const apiData: ResetPasswordDTO = {
    newPassword: formData.get("newPassword") as string,
    email: formData.get("email") as string,
    code: formData.get("code") as string,
  };
  // TO DO Result'a type verilecek. Error handling yapılacak.
  const result = await apiEndpoints.resetPassword(apiData);
  if (result.success) {
    eventBus.emit("notify", {
      type: "success",
      message: "Şifreniz başarıyla değiştirildi. Giriş yapabilirsiniz.",
    });
    return redirect("/login");
  }
}
